module.exports = __webpack_public_path__ + "static/media/french.bc433730.svg";